export default {
  screenImagesPath: '/images/screens/',
}
